import React from "react"
import PropTypes from "prop-types"

const renderDescriptionBlock = ({ type, text, items }, index) => {
  if (type === "list" && items?.length) {
    return (
      <ul key={`${type}-${index}`}>
        {items.map(item => (
          <li key={item}>{item}</li>
        ))}
      </ul>
    )
  }

  if (!text) {
    return null
  }

  return <p key={`${type}-${index}`}>{text}</p>
}

const ShopifyThemesImageWithText = ({
  title,
  description,
  image,
  button,
  isReverse = false,
}) => {
  const contentMarkup = (
    <div className="image-with-text__content">
      <h2 className="image-with-text__title">{title}</h2>

      <div className="image-with-text__description">
        {description.map(renderDescriptionBlock)}
      </div>

      <div className="image-with-text__actions">
        <a
          href={button.url}
          className="image-with-text__link button button--primary"
          target={button.target}
          rel={button.target === "_blank" ? "noreferrer" : undefined}
          id={button.id}
        >
          {button.text}
        </a>
      </div>
    </div>
  )

  const imageMarkup = (
    <div className="image-with-text__image-wrapper">
      <img
        className="image-with-text__image"
        src={image.src}
        srcSet={image.srcSet}
        sizes={image.sizes}
        width={image.width}
        height={image.height}
        loading="lazy"
        decoding="async"
        alt={image.alt}
      />
    </div>
  )

  return (
    <section className="image-with-text">
      <div className="image-with-text__container">
        {isReverse ? (
          <>
            {imageMarkup}
            {contentMarkup}
          </>
        ) : (
          <>
            {contentMarkup}
            {imageMarkup}
          </>
        )}
      </div>
    </section>
  )
}

ShopifyThemesImageWithText.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.arrayOf(
    PropTypes.shape({
      type: PropTypes.oneOf(["text", "list"]).isRequired,
      text: PropTypes.string,
      items: PropTypes.arrayOf(PropTypes.string),
    })
  ).isRequired,
  image: PropTypes.shape({
    src: PropTypes.string.isRequired,
    srcSet: PropTypes.string.isRequired,
    sizes: PropTypes.string.isRequired,
    width: PropTypes.number.isRequired,
    height: PropTypes.number.isRequired,
    alt: PropTypes.string.isRequired,
  }).isRequired,
  button: PropTypes.shape({
    text: PropTypes.string.isRequired,
    url: PropTypes.string.isRequired,
    target: PropTypes.string,
    id: PropTypes.string,
  }).isRequired,
  isReverse: PropTypes.bool,
}

export default ShopifyThemesImageWithText
